import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { makeStyles } from "@material-ui/core";
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from "@material-ui/pickers";
import { getSelectedBinderPolicy } from "../../store/mybinder";
import DateFnsUtils from "@date-io/date-fns";
import { Constents } from "./Constant";
import translations from "../../utils/translations";
import { getBrokerInformation } from "../../store/broker";
import frLocale from "date-fns/locale/fr";
import enLocale from "date-fns/locale/en-US";
const useStyles = makeStyles((theme) => ({
  datePicker: {
    "& .MuiInputBase-root": {
      padding: 0,
      backgroundColor: "#ffffff",
      width: "10.4rem",
      marginBottom: "0.5rem",
      "& .MuiButtonBase-root": {
        padding: 0,
        paddingRight: 10,
        backgroundColor: "#ffffff",
        minWidth: "100%",
      },
      "& .MuiInputBase-input": {
        padding: 10,
        paddingLeft: 10,
        backgroundColor: "#ffffff",
      },
    },
  },
}));
const DatePicker = ({
  setValue,
  isEditBinder,
  handleSubmit,
  onSubmit,
  responseid,
  id,
  quotesExpiry,
  responseDetail,
}) => {
  const binderPolicyData = useSelector(getSelectedBinderPolicy);
  const classes = useStyles();
  const dispatch = useDispatch();
  let BrokerInfo = useSelector(getBrokerInformation);
  const languagepreference = BrokerInfo.information.languagepreference;
  var d = new Date(quotesExpiry);
  if (!quotesExpiry || !d instanceof Date || !isFinite(d)) {
    d = null;
  }
  const [effectiveDate, setEffectiveDate] = useState(
    new Date(binderPolicyData?.effectivedate)
  );
  const [expiryDate, setExpiryDate] = useState(
    new Date(binderPolicyData?.expirydate)
  );
  const locale = languagepreference === "fr" ? frLocale : enLocale;

  const [quotesExpiryDate, setQuotesExpiryDate] = useState(d); //new Date(quotesExpiry)
  const handleEffectiveDateChange = (date) => {
    setEffectiveDate(date);
    setTimeout(() => {
      setValue({ effectivedate: date });
    }, 400);
  };
  const handleExpiryDateChange = (date) => {
    setExpiryDate(date);
    setTimeout(() => {
      setValue({ expirydate: date });
    }, 400);
  };

  const handleQuotesExpiryDateChange = (date) => {
    var datevalue = new Date(date);
    if (date && datevalue instanceof Date && isFinite(datevalue)) {
      const year = datevalue.getFullYear();
      const month = String(datevalue.getMonth() + 1).padStart(2, '0');
      const day = String(datevalue.getDate()).padStart(2, '0');
      datevalue = `${year}-${month}-${day}`;
      setQuotesExpiryDate(date);
    } else {
      datevalue = null;
    }
    setTimeout(() => {
      setValue({ value: datevalue ? datevalue : datevalue, id: id });
    }, 400);
  };

  const dateFormatter = (str) => {
    return str;
  };
  return responseid != undefined || null ? (
    <div style={{ display: "flex", width: "100%" }}>
      <MuiPickersUtilsProvider utils={DateFnsUtils} locale={locale}>
        <KeyboardDatePicker
          autoOk={true}
          variant="inline"
          className={classes.datePicker}
          placeholder={
            languagepreference === "fr" ? "jj/mm/aaaa" : "mm/dd/yyyy"
          }
          cancelLabel={translations[languagepreference].cancel}
          todayLabel={languagepreference === "fr" ? "Aujourd'hui" : "Today"}
          inputVariant="outlined"
          showtodaybutton={true}
          value={quotesExpiryDate}
          format="yyyy-MM-dd"
          onChange={handleQuotesExpiryDateChange}
          rifmFormatter={dateFormatter}
          disabled={
            responseid != undefined
              ? responseDetail?.source == "manual"
                ? false
                : true
              : isEditBinder
          }
        />
      </MuiPickersUtilsProvider>
    </div>
  ) : null;
  // <form id="form" onSubmit={handleSubmit(onSubmit)}>
  //   <div style={{ display: "flex", width: "100%" }}>
  //     <label
  //       className="col-sm-7 col-form-label"
  //       style={{
  //         fontFamily: "GibsonRegular",
  //         display: "flex",
  //         marginTop: "2px",
  //         paddingLeft: "5px",
  //       }}
  //     >
  //       {Constents.EFF_DATE}
  //     </label>
  //     <MuiPickersUtilsProvider utils={DateFnsUtils}>
  //       <KeyboardDatePicker
  //         autoOk
  //         variant="inline"
  //         className={classes.datePicker}
  //         inputVariant="outlined"
  //         format="yyyy-MM-dd"
  //         value={effectiveDate}
  //         onChange={(date) => handleEffectiveDateChange(date)}
  //         disabled={isEditBinder}
  //       />
  //     </MuiPickersUtilsProvider>
  //   </div>
  //   <div style={{ display: "flex", width: "100%" }}>
  //     <label
  //       className="col-sm-7 col-form-label"
  //       style={{
  //         fontFamily: "GibsonRegular",
  //         display: "flex",
  //         marginTop: "2px",
  //         paddingLeft: "5px",
  //       }}
  //     >
  //       {Constents.EXPIRY_DATE}
  //     </label>
  //     <MuiPickersUtilsProvider utils={DateFnsUtils}>
  //       <KeyboardDatePicker
  //         autoOk
  //         variant="inline"
  //         className={classes.datePicker}
  //         inputVariant="outlined"
  //         format="yyyy-MM-dd"
  //         value={expiryDate}
  //         onChange={(date) => handleExpiryDateChange(date)}
  //         disabled={isEditBinder}
  //       />
  //     </MuiPickersUtilsProvider>
  //   </div>
  // </form>
};

export default DatePicker;
